"use client";

import createSvgIcon from "@mui/material/utils/createSvgIcon";
const Light = createSvgIcon(<svg fill="currentColor" viewBox="0 0 24 24">
    <path d="M19.0765 9.48063H12.1242L15.5905 0L5 14.5194H11.9522L8.48592 24L19.0765 9.48063Z" />
  </svg>, "Light");
export default Light;